<template>
    <div class="ma-4">
        <v-layout row wrap class="pa-2">
              <v-flex xs12>
                <v-btn fab x-small @click="$router.go(-1)">
                  <v-icon>navigate_before</v-icon>
                    
                  </v-btn>
              </v-flex>

              <v-flex xs12>
                <h1 class="text-center mb-5">Finances Report</h1>
              </v-flex>
              
              <v-flex xs12 md3 class="pa-1">
                  <v-menu
                      ref="calendarMenu"
                      v-model="calendarMenu"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                      <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="startDate"
                          label="Start Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules='requiredField'
                      ></v-text-field>
                      </template>
                      <v-date-picker
                      v-model="startDate"
                      no-title
                      scrollable
                      :rules='requiredField'

                      >
                      <v-spacer></v-spacer>
                      <v-btn
                          text
                          color="primary"
                          @click="calendarMenu = false"
                      >
                          Cancel
                      </v-btn>
                      <v-btn
                          text
                          color="primary"
                          @click="$refs.calendarMenu.save(date)"
                      >
                          OK
                      </v-btn>
                      </v-date-picker>
                  </v-menu>
                  
              </v-flex>

              <v-flex xs12 md3 class="pa-1">
                 <v-menu
                      ref="calendar2Menu"
                      v-model="calendar2Menu"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                      <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="endDate"
                          label="End Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules='requiredField'

                      ></v-text-field>
                      </template>
                      <v-date-picker
                      v-model="endDate"
                      no-title
                      scrollable
                      :rules='requiredField'

                      >
                      <v-spacer></v-spacer>
                      <v-btn
                          text
                          color="primary"
                          @click="calendar2Menu = false"
                      >
                          Cancel
                      </v-btn>
                      <v-btn
                          text
                          color="primary"
                          @click="$refs.calendar2Menu.save(date)"
                      >
                          OK
                      </v-btn>
                      </v-date-picker>
                  </v-menu>
              </v-flex>

              <v-flex xs12 md2 class="pa-1 mb-2">
                <v-select
                    label="Select a Program"
                    :items="programs"
                    item-text="Name"
                    item-value="Name"
                    v-model="program"
                    clearable
                    @change="financeQuery()"
                ></v-select>
              </v-flex>

              <v-flex xs12 md3 class="pa-1 mb-2">
                <v-select 
                    label="Select a Client"
                    :items="clients"
                    item-text="Name"
                    item-value="._id"
                    v-model="ClientID"
                    @change="financeQuery()"
                    clearable
                  ></v-select>
              </v-flex>

              <v-flex xs12 md3 class="mt-5 mb-5 pl-5">
                 <v-btn @click="financeQuery()">Search</v-btn>
              </v-flex>

              <v-flex xs12 class="pa-2">
                  <v-data-table
                    :headers="headers"
                    :items="finances"
                    sort-by="Name"
                    sort-asc
                    class="elevation-1"
                    :loading="isLoading"
                    loading-text="Loading Finances"
                    items-per-page="100"

                  >
                  <template v-slot:item.select="{ item }">
                      <v-btn
                        x-small
                        class="white--text"
                        color="#2b3990"
                        @click="onViewItem(item)"
                      >
                        view
                      </v-btn>
                  </template>
                  </v-data-table>

              </v-flex>
          </v-layout>
      <v-dialog
          v-model="dialog"
          max-width="90vh"
          scrollable
          :retain-focus="false"
          persistent
      >
        <v-card height="100%">
          <v-toolbar color="primary" dark>Viewing Finances</v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <v-row class="mt-3">
              <v-col cols="12" md="6">
                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="month"
                        label="Month"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                    ></v-text-field>
                  </template>
                  <v-text-field
                      type="month"
                      v-model="financeDate"
                      readonly
                  ></v-text-field>
                </v-menu>
              </v-col>

              <v-col cols="12" md="6">
                <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="newDate"
                        label="Day"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                    ></v-text-field>
                  </template>
                  <v-text-field
                      v-model="newDate"
                      readonly
                  ></v-text-field>
                </v-menu>
              </v-col>
            </v-row>

            <v-row class="mt-1">
              <v-col cols="12" md="12">
                <v-text-field
                    label="Amount"
                    prefix="$"
                    v-model="newAmount"
                    outlined
                    type="number"
                    readonly
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="mt-n8">
              <v-col cols="12" md="12">
                <v-checkbox
                    label="Opened By"
                    hide-details
                    v-model="checkedSignature"
                    readonly
                ></v-checkbox>
                <v-text-field v-model="newSignature" readonly></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">
              <div class="text-caption text-sm-body-1">
                Cancel
              </div>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>
<script>
import axios from 'axios'
import {tz} from "../../../utils/timezone";
import moment from "moment";
// import moment from 'moment'
// import Foot from '../components/Footer'

const url = require("../../client_config/config").url;

  export default {
    components: {
    },
    data: () => ({
    headers: [
      {
        text: 'Start Date',
        align: 'start',
        sortable: true,
        value: 'Date',
      },
      { text: "Client", value: "ClientID.Name" },
      { text: "Action", value: "Action" },
      { text: "Amount", value: "Amount" },
      { text: "Payee", value: "Payee" },
      { text: "Signature", value: "Signature" },
      { text: "", value: "select" },

      // { text: "Actions", value: "actions", sortable: false },
    ],
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    clients: [],
    finances: [],
    startDate: "",
    endDate: "",
    ClientID: '',
    calendarMenu: false,
    calendar2Menu: false,
    report: '',
    clientName: '',
    isLoading: false,
    program: '',
    programs: [],
    requiredField: [
        v => !!v || 'This is required',
    ],
    dialog: false,
    menu: '',
    month: '',
    financeDate: '',
    menu1: '',
    newDate: '',
    newAmount: '',
    checkedSignature: '',
    newSignature: '',
    CloseOut: '',
    }),

    computed: {
      
    },

    created() {
      this.getClients();
      this.getPrograms();
      this.financeQuery();
      

    },

    methods: {
      initialize() {
        this.clients = [];
      },

      getPrograms () {
        axios.get(`${url}/units`).then(async res => {
          this.programs = res.data.units;

        });
      },

      getClients () {
        axios.get(`${url}/clients`).then(async res => {
          this.clients = res.data.clients;
          
        });      
      },
      close() {
        this.dialog = false;
        this.seditInfo = false;
        this.passdialog = false;
        this.chgimg = false;

      },

      financeQuery() {
        this.finances = [];
        this.isLoading = true;

        this.program = this.program || '';
        this.startDate = this.startDate || '';
        this.endDate = this.endDate || '';
        this.ClientID = this.ClientID || '';


        axios.get(`${url}/finances/reports?program=${this.program}&startDate=${this.startDate}&endDate=${this.endDate}&clientId=${this.ClientID}`).then(res => {
          this.finances = res.data.finances
          this.isLoading = false
        });
      },

      getClientID(item) {
        this.client = item.ClientID._id;
        window.localStorage.setItem('clientId', this.client)
        console.log(this.client)
      },

      onViewItem(item) {
        this.dialog = true;
        this.financeID = item._id;
        this.CloseOut = item.CloseOut;
        this.newDate = tz(item.Date, this.userTimezone).format("YYYY-MM-DD");
        this.month = item.Month;
        this.newAmount = item.Amount;
        this.newTransactionMethods = item.TransactionMethods;
        this.newNotes = item.Notes;
        this.newPayee = item.Payee;
        this.newSigned = item.Signed;
        this.newSignature = item.StaffSignature
            ? ((this.checkedSignature = true), item.StaffSignature)
            : ((this.checkedSignature = false), "");
        this.newClientSignature = item.ClientSignature;
        this.newReceipt = item.Receipt?.Name || "";
        if (item.Receipt !== "") {
          this.newReceiptImage = item.Receipt?.AWSLink || "";
        }

        this.minDate = moment(new Date(item.Date))
            .startOf("month")
            .format("YYYY-MM-DD");
        this.maxDate = moment( new Date(item.Date))
            .endOf("month")
            .format("YYYY-MM-DD");
      },
    }
  }
</script>
<style>
@media only screen and (max-width: 480px) {

}
</style>